import type { ISecurityRepository } from '../../domain/ports';
import { securityApi } from '../api';
import type {
  SecurityParams,
  HistoryResult,
  GetSecurityLogsData,
  SecurityLogsResult,
  RequestPasswordResetData,
  PasswordResetResult,
  VerifyResetTokenData,
  ResetPasswordData,
  ApiResponse,
} from '../../application/dto/dtos';

/**
 * Adapte securityApi vers le port ISecurityRepository.
 */
export class SecurityRepository implements ISecurityRepository {
  getSecurityParams(idUtilisateur: string): Promise<ApiResponse<SecurityParams>> {
    return securityApi.getSecurityParams(idUtilisateur);
  }

  getHistory(idUtilisateur: string, options?: {
    type?: 'TOUS' | 'CONNEXIONS' | 'MODIFICATIONS' | 'SECURITE';
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<HistoryResult>> {
    return securityApi.getHistory(idUtilisateur, options);
  }

  getSecurityLogs(data: GetSecurityLogsData): Promise<ApiResponse<SecurityLogsResult>> {
    return securityApi.getSecurityLogs(data);
  }

  requestPasswordReset(data: RequestPasswordResetData): Promise<ApiResponse<PasswordResetResult>> {
    return securityApi.requestPasswordReset(data);
  }

  verifyResetToken(data: VerifyResetTokenData): Promise<ApiResponse<{ valid: boolean }>> {
    return securityApi.verifyResetToken(data);
  }

  resetPassword(data: ResetPasswordData): Promise<ApiResponse<void>> {
    return securityApi.resetPassword(data);
  }
}
